/* PhotoHouse V11.2: release-mode readiness + preview stock guard.
   Catalog comes from Shopify Liquid all_products['frames-for-prints'] at render time.
   Does NOT create bundles, change inventory, call cart APIs or guarantee server-side checkout protection.
   Before release: configure server-side bundles + backend denial of missing SKUs,
   then enable Shopify bundle availability in theme settings and test checkout.
*/
(function () {
  'use strict';
  var MIN_DELAY = 0;
  function list(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clean(v) {
    return String(v || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function sizeKey(v) {
    var m = clean(v).replace(/[×✕]/g, 'x').match(/(\d+)\s*[x]\s*(\d+)/);
    return m ? Number(m[1]) + 'x' + Number(m[2]) : '';
  }
  function finishKey(v) {
    var x = clean(v);
    if (/printing only|print only|without frame|no frame|unframed|ללא מסגרת|הדפס בלבד|הדפסה בלבד/.test(x)) return 'print';
    if (/^\s*(?:black frame|מסגרת שחורה|מסגרת שחור|שחור|black)\s*$/.test(x)) return 'black';
    if (/^\s*(?:amber frame|מסגרת ענבר|ענבר|amber)\s*$/.test(x)) return 'amber';
    if (/^\s*(?:wenge frame|מסגרת וונגה|מסגרת ונגה|וונגה|ונגה|wenge)\s*$/.test(x)) return 'wenge';
    if (/dibond|דיבונד|acrylic|אקרילי|acryl/.test(x)) return 'other';
    return 'unknown';
  }
  function optionIndex(names, kind) {
    for (var i = 0; i < names.length; i++) {
      var x = clean(names[i]);
      if (kind === 'size' && /size|מידה|מידות|גודל/.test(x)) return i;
      if (kind === 'frame' && /frame|framing|finish|גימור|מסגר/.test(x)) return i;
    }
    return -1;
  }
  function makeText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function init(article) {
    if (!article || article.dataset.phV10Initialized === '1') return;
    var dataNode = article.querySelector('script[data-ph-v10-frame-data]');
    var form = article.querySelector('.product__form form');
    var variantSelect = form && form.querySelector('select.productSelect[name="id"]');
    var add = form && form.querySelector('.product__add-to-cart');
    if (!dataNode || !variantSelect || !add) return;
    var source;
    try { source = JSON.parse(dataNode.textContent || ''); } catch (err) { return; }
    if (!source || !Array.isArray(source.productVariants)) return;
    article.dataset.phV10Initialized = '1';
    var names = source.productOptions || [];
    var sizePos = optionIndex(names, 'size');
    var framePos = optionIndex(names, 'frame');
    if (sizePos < 0 || framePos < 0 || sizePos === framePos) return;
    var variants = {};
    var availability = {};
    var frames = source.frameVariants || [];
    var locale = source.locale === 'he' || /^he\b/i.test(document.documentElement.lang || '') ? 'he' : 'en';
    var strings = locale === 'he' ? {
      out: 'אזל מהמלאי', missing: 'לא זמין', unknown: 'לא ניתן לבדוק זמינות',
      outNote: 'המסגרת שבחרתם אזלה מהמלאי. בחרו מסגרת אחרת או הדפסה בלבד.',
      missingNote: 'אין מסגרת תואמת לבחירה הזו. בחרו אפשרות אחרת או הדפסה בלבד.',
      unknownNote: 'לא הצלחנו לאמת את מלאי המסגרות. כרגע לא ניתן להוסיף מסגרת לסל.'
    } : {
      out: 'Sold out', missing: 'Unavailable', unknown: 'Availability unavailable',
      outNote: 'This frame is sold out. Choose another frame or print only.',
      missingNote: 'No matching frame is available for this selection. Choose another option or print only.',
      unknownNote: 'Frame inventory could not be verified. Framed prints cannot be added to cart right now.'
    };
    function snapshot(v) {
      if (!v) return { status:'unknown' };
      var opt = [v.option1, v.option2, v.option3];
      var frame = finishKey(opt[framePos]);
      if (frame === 'print' || frame === 'other') return v.available === false ? { status:'missing' } : { status:'ok' };
      if (frame === 'unknown') return { status:'missing' };
      var sz = sizeKey(opt[sizePos]);
      if (!sz) return { status:'missing' };
      if (!source.catalogReady && source.availabilityMode !== 'shopify-bundle-variants') return { status:'unknown' };
      var found = availability[frame + '|' + sz];
      if (!found || found.length !== 1) return { status:'missing' };
      var matched = found[0];
      // RELEASE MODE: after the fixed-bundle catalog cutover, Shopify's parent
      // variant.available is the authoritative result of component stock.
      // The catalog fallback below provides *membership* (size+finish) only:
      // its dated quantities MUST NOT be used to approve/deny live sales.
      if (source.availabilityMode === 'shopify-bundle-variants') {
        return v.available === false ? {status:'soldout'} : {status:'ok'};
      }
      if (matched.inventoryManaged !== 'shopify') return { status:'unknown' };
      if (matched.policy !== 'deny') return { status:'unknown' };
      // A Shopify fixed bundle can mark the parent variant unavailable when its
      // frame component reaches zero. Show the confirmed frame-level Sold out
      // label before falling back to generic variant unavailability.
      if (!matched.available || Number(matched.quantity) <= 0) return {status:'soldout'};
      if (v.available === false) return {status:'missing'};
      return {status:'ok',remaining:matched.quantity};
    }
    frames.forEach(function (v) {
      var finish = finishKey(v.finish), sz = sizeKey(v.size);
      if (finish === 'unknown' || !sz) return;
      var key = finish + '|' + sz;
      if (!availability[key]) availability[key] = [];
      availability[key].push(v);
    });
    source.productVariants.forEach(function (v) { variants[String(v.id)] = v; });
    function current() {
      return snapshot(variants[String(variantSelect.value)]);
    }
    function blocked(state) { return state.status !== 'ok'; }
    var note = document.createElement('p');
    note.className = 'ph-v10__stock-note';
    note.setAttribute('role', 'status');
    note.setAttribute('aria-live', 'polite');
    note.hidden = true;
    add.insertAdjacentElement('afterend', note);
    // The dated Preview snapshot banner is intentionally omitted from the PDP.
    // Inventory guards, disabled frame choices and unknown-stock safety notice remain active.
    var originalText = add.querySelector('.add-to-cart__text');
    var lastNormalText = originalText ? originalText.textContent.trim() : '';
    var sticky = document.querySelector('[data-ph-v6-atc][data-product-section="' + article.id.replace(/^section-/, '') + '"]');
    var mobile = document.querySelector('[data-ph-v1-mobile-atc][data-product-section="' + article.id.replace(/^section-/, '') + '"]');
    var lockedBefore = false;
    var disablePrior = false;
    var running = false, raf = null, retries = 0;
    var initialAvailabilityResolved=false;
    function updateButtons(state) {
      var isBlocked = blocked(state);
      var wasGuarded = add.getAttribute('data-ph-v10-locked') === 'true';
      if (isBlocked && !wasGuarded) {
        disablePrior = add.disabled;
        if (originalText && !lockedBefore) lastNormalText = originalText.textContent.trim() || lastNormalText;
        add.setAttribute('data-ph-v10-locked', 'true');
      }
      if (!isBlocked && wasGuarded) add.removeAttribute('data-ph-v10-locked');
      if (isBlocked) {
        if (!add.disabled) add.disabled = true;
        if (originalText) makeText(originalText, state.status === 'soldout' ? strings.out : state.status === 'missing' ? strings.missing : strings.unknown);
      } else if (wasGuarded) {
        if (add.disabled && !['working','loading','done'].some(function (c) { return add.classList.contains(c); })) add.disabled = false;
        if (originalText && lastNormalText) makeText(originalText, lastNormalText);
      }
      lockedBefore = isBlocked;
      [sticky && sticky.querySelector('[data-ph-v6-button]'), mobile && mobile.querySelector('[data-ph-v1-mobile-button]')].forEach(function (b) {
        if (!b) return;
        if (isBlocked) {
          if (!b.hasAttribute('data-ph-v10-lock-origin')) b.setAttribute('data-ph-v10-lock-origin', b.disabled ? 'true' : 'false');
          if (!b.disabled) b.disabled = true;
          makeText(b, state.status === 'soldout' ? strings.out : state.status === 'missing' ? strings.missing : strings.unknown);
        } else if (b.hasAttribute('data-ph-v10-lock-origin')) {
          var originallyDisabled = b.getAttribute('data-ph-v10-lock-origin') === 'true';
          b.removeAttribute('data-ph-v10-lock-origin');
          if (!add.disabled) b.disabled = false;
          if (lastNormalText) makeText(b, lastNormalText);
        }
      });
      article.classList.toggle('ph-v10__locked', isBlocked);
      if (sticky) sticky.classList.toggle('ph-v10__locked', isBlocked);
      if (mobile) mobile.classList.toggle('ph-v10__locked', isBlocked);
      // Disabled frame choices already expose stock state in the selector.
      // Only show a notice if live/snapshot availability cannot be verified.
      note.hidden = state.status !== 'unknown';
      if (state.status === 'unknown') makeText(note, strings.unknownNote);
    }
    function updateFrameButtons() {
      var chosen = variants[String(variantSelect.value)];
      if (!chosen) return;
      var size = [chosen.option1, chosen.option2, chosen.option3][sizePos];
      var frameHolder = list(article, '.product__variant-holder').find(function (node) {
        var el = node.querySelector('select.product__variant');
        return el && el.dataset.option === 'option' + (framePos + 1);
      });
      if (!frameHolder) return;
      list(frameHolder, '.ph-v2__option--frame[data-ph-v2-value]').forEach(function (button) {
        var pseudo = { available:true, option1:null, option2:null, option3:null };
        pseudo['option' + (sizePos + 1)] = size;
        pseudo['option' + (framePos + 1)] = button.getAttribute('data-ph-v2-value');
        var matchingVariant = source.productVariants.find(function (candidate) {
          var options = [candidate.option1,candidate.option2,candidate.option3];
          return sizeKey(options[sizePos]) === sizeKey(size) &&
            finishKey(options[framePos]) === finishKey(button.getAttribute('data-ph-v2-value'));
        });
        var result = matchingVariant ? snapshot(matchingVariant) : {status:'missing'};
        var no = blocked(result);
        var orig = button.getAttribute('data-ph-v10-original-disabled');
        if (orig === null) {
          orig = button.disabled ? 'true' : 'false';
          button.setAttribute('data-ph-v10-original-disabled', orig);
        }
        button.disabled = orig === 'true' || no;
        button.classList.toggle('ph-v10__soldout', result.status === 'soldout');
        button.classList.toggle('ph-v10__unavailable', result.status === 'missing' || result.status === 'unknown');
        var badge = button.querySelector('.ph-v10__badge');
        if (no) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'ph-v10__badge';
            button.appendChild(badge);
          }
          makeText(badge, result.status === 'soldout' ? strings.out : result.status === 'missing' ? strings.missing : strings.unknown);
          button.setAttribute('aria-label', (button.querySelector('.ph-v2__option-label') || button).textContent.trim() + ' — ' + badge.textContent);
        } else {
          if (badge) badge.remove();
          button.removeAttribute('aria-label');
        }
      });
    }
    function sync() {
      raf = null;
      if (running) return;
      running = true;
      try {
        var state = current();
        updateButtons(state);
        updateFrameButtons();
        if(!initialAvailabilityResolved){
          var defaultFrameHolder=list(article,'.product__variant-holder').find(function(holder){
            var select=holder.querySelector('select.product__variant');
            return select&&select.dataset.option==='option'+(framePos+1);
          });
          var initialButtons=defaultFrameHolder&&list(defaultFrameHolder,'.ph-v2__option--frame[data-ph-v2-value]');
          if(initialButtons&&initialButtons.length){
            initialAvailabilityResolved=true;
            var directVariant=/(?:^|[?&])variant=/.test(window.location.search);
            if(!directVariant&&(state.status==='soldout'||state.status==='missing')){
              var availableOption=initialButtons.find(function(button){return !button.disabled;});
              if(availableOption){
                window.requestAnimationFrame(function(){
                  if(!availableOption.isConnected||availableOption.disabled)return;
                  var still=current();
                  if(still.status==='soldout'||still.status==='missing')availableOption.click();
                });
              }
            }
          }
        }
      } finally { running = false; }
    }
    function schedule() { if (raf !== null) return; raf = requestAnimationFrame(sync); }
    // Event delegation handles Kingdom's jQuery-only change events and V2 UI buttons.
    article.addEventListener('change', schedule, true);
    article.addEventListener('click', function (event) {
      var target = event.target.closest('.product__add-to-cart');
      if (!target) return;
      if (blocked(current())) { event.preventDefault(); event.stopImmediatePropagation(); schedule(); }
    }, true);
    form.addEventListener('submit', function (event) {
      if (blocked(current())) { event.preventDefault(); event.stopImmediatePropagation(); schedule(); }
    }, true);
    if (window.jQuery && window.jQuery.fn) {
      window.jQuery(variantSelect).on('change.phV10', schedule);
      window.jQuery(article).find('select.product__variant').on('change.phV10', schedule);
    }
    [sticky, mobile].forEach(function (bar) {
      if (!bar) return;
      bar.addEventListener('click', function (event) {
        if (!event.target.closest('button')) return;
        if (blocked(current())) { event.preventDefault(); event.stopImmediatePropagation(); schedule(); }
      }, true);
    });
    var root = article.querySelector('.product__variants');
    if (root) new MutationObserver(schedule).observe(root, { childList:true, subtree:true });
    new MutationObserver(schedule).observe(add, { attributes:true, attributeFilter:['disabled','class'], subtree:false });
    // Two extra passes catch the asynchronous initialization of the original Kingdom selectors.
    schedule();
    setTimeout(schedule, 300);
    setTimeout(schedule, 1200);
  }
  function mount() {
    list(document, 'article.product.page-section').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
